import React, { useEffect, useState } from "react";
import Header from "../../Header";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Address from "./Address/Address";
import Loading from "../../pages/Loading/Loading";
import ConnectionError from "../../ConnectionError/ConnectionError";
import { fetchWithTimeout } from "../../../utils/fetchWithTimeout";

function ManagerAddresessesSelect({}) {
  const [content, setContent] = useState();
  const [loadError, setLoadError] = useState(null);
  const [retryKey, setRetryKey] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();

  const selectedAddresses = useSelector(
    (state) => state.manager.selectedAddresses
  );

  useEffect(() => {
    async function tryGetAddresses() {
      try {
        const response = await fetchWithTimeout(
          `https://api-erkon.tech/mobile/hs/ObmenMP/AddressListPWA`,
          {
            headers: {
              token: localStorage.getItem("tokenMANAGER"),
            },
            method: "POST",
          }
        );

        if (response.status === 200) {
          const data = await response.json();

          if (Array.isArray(data)) {
            setContent(data);
            setLoadError(null);
          } else {
            setLoadError('invalid');
          }
        } else if (response.status === 401) {
          localStorage.removeItem('tokenMANAGER');
          window.location.replace('/login');
        } else {
          setLoadError(response.status);
        }
      } catch (e) {
        setLoadError('network');
      }
    }

    tryGetAddresses();
  }, [retryKey]);

  if (content) {
    return (
      <>
        <Header
          isSelector={true}
          headerTitle={"Адрес"}
          backRedirect={-1}
          search={true}
          searchValue={searchInput}
          setSearchInput={setSearchInput}
        />
        <div className="contentContainer">
          <div className="contentFields">
            {content
              .filter((ticket) =>
                ticket.name
                  .toLowerCase()
                  .includes(searchInput.toLocaleLowerCase())
              )
              .map((ticket, index) => {
                return (
                  <Address
                    content={content}
                    setContent={setContent}
                    ticket={ticket}
                    index={index}
                  />
                );
              })}
          </div>
        </div>
        <div className="footerSendButtonAddress">
          <div className="sendButtonPlaceholder">
            <div style={{ marginRight: "auto", marginLeft: "auto" }}>
              <span className="footerTxt">Выбрано </span>
              <span className="footerTxtBold">{selectedAddresses.size}</span>
              <span className="footerTxt"> адресов</span>
            </div>
            <button onClick={() => navigate(-1)} className="sendButtonActive">
              Готово
            </button>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>
    );
  } else {
    return loadError
      ? <ConnectionError status={loadError} onRetry={() => { setLoadError(null); setRetryKey(key => key + 1); }} />
      : <Loading />;
  }
}

export default ManagerAddresessesSelect;
